import React from 'react';
import { Card, Typography, Divider } from 'antd';
import { parseAndSanitizeMarkdown, MarkdownStyles } from '../../../utils/markdownUtils'; // <--- Our new utility
import { Bubble } from '@ant-design/x';


const ViewableResponse = ({ markdownText, title }) => {
  // Convert your raw text to HTML
  const htmlContent = parseAndSanitizeMarkdown(markdownText);

  return (
    <Card
      bordered={false}
      style={{
        background: 'transparent',
        maxWidth: '800px',
      }}
    >
      <style>{MarkdownStyles}</style>
      {title && (
        <>
          <Typography.Title level={3}>{title}</Typography.Title>
          <Divider />
        </>
      )}

      {/* Example custom CSS styling for the rendered markdown */}
      {/* Render the sanitized+MarkdownIt HTML */}
      <div
        className="markdown-content"
        style={{
          lineHeight: 2,
          fontSize: '0.95rem',
        }}
        dangerouslySetInnerHTML={{ __html: htmlContent }}
      />
    </Card>
  );
};

export default ViewableResponse;
